import React, { useState } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Login from "./Viklang/Auth/Login";
import SideNavBar from "./Viklang/sidebar";
import NavBar from "./Viklang/navbar";
import TaskData from "./Viklang/pDetails";
import ProductAdd from "./Viklang/productAdd";
import ProductEditForm from "./Viklang/productEdit";
import ContactUs from "./Viklang/contactus";
import Category from "./Viklang/category";
import Services from "./Viklang/services";
import Treatments from "./Viklang/treatment";
import Carousal from "./Viklang/heroImages";
import "./App.css";

const RequireAuth = ({ children }) => {
  const token = localStorage.getItem("authToken");
  const location = useLocation();

  if (!token) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

const AppContent = () => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const location = useLocation(); 

  const pathToTitle = {
    "/": "Product Details",
    "/product-add": "Add Product",
    "/product-details": "Product Details",
    "/category-details": "Categories",
    "/services-details": "Services Details",
    "/treatment-details": "Treatment Details",
    "/enquiry-details": "Enquiry Details",
    "/carousel-details": "Hero Images",
  };

  const OpenPage = pathToTitle[location.pathname] || "Product Details";

  const toggleSidebar = () => {
    setIsSidebarCollapsed(!isSidebarCollapsed);
  };

  return (
    <div className="flex h-screen bg-gray-100">
      <SideNavBar
        isCollapsed={isSidebarCollapsed}
        toggleSidebar={toggleSidebar}
        setIsCollapsed={setIsSidebarCollapsed}
      />

      <div
        className={`flex-1 flex flex-col overflow-hidden transition-all duration-300 ${
          isSidebarCollapsed ? "ml-[3.5rem]" : "ml-[13.9rem]"
        }`}
      >
        <NavBar title={OpenPage} />

        <div className="flex-1 overflow-auto bg-gray-100">
          <Routes>
            <Route path="/" element={<TaskData />} />
            {/* <Route path="/" element={<Dashboard />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/user-details" element={<UserData isSidebarCollapsed={isSidebarCollapsed} />} /> */}
            <Route path="/product-add" element={<ProductAdd />} />
            {/* <Route path="/task-edit/:id" element={<TaskEdit />} />
            <Route path="/task-details/:taskGroupId" element={<TaskDataById />} /> */}
            <Route path="/product-edit/:id" element={<ProductEditForm />} />
            <Route path="/product-details" element={<TaskData />} />
            <Route path="/category-details" element={<Category />} />
            <Route path="/services-details" element={<Services />} />
            <Route path="/treatment-details" element={<Treatments />} />
            <Route path="/enquiry-details" element={<ContactUs />} />
            <Route path="/carousel-details" element={<Carousal />} />
            
            {/* <Route path="/delete-request" element={<DeleteRequest />} /> */}
          </Routes>
        </div>
      </div>
    </div>
  );
};

const App = () => (
  <BrowserRouter>
    <Routes>
      {/* Public Routes */}
      <Route path="/login" element={<Login />} />
      {/* <Route path="/delete-account" element={<DeleteAccount />} /> */}

      {/* Protected Routes */}
      <Route
        path="*"
        element={
          <RequireAuth>
            <AppContent />
          </RequireAuth>
        }
      />
    </Routes>

    <ToastContainer
      position="top-right"
      autoClose={3000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="colored"
    />
  </BrowserRouter>
);

export default App;
